export default {
  subtitle: "Transaction Limits",
  path: "transaction_limits",
  paragraph: "Once a customer reaches its limits, FacilitaPay will send a webhook requesting that customer's Tax Declaration for raising this customer's limit. The transaction will stay on hold until the required info/documentation is sent and processed by our back-office staff. Below is an example of a webhook that is triggered if a customer needs to provide his/her Tax Decaration and a document proving his/her address is where he/she lives or has ownership (Proof of address).",
  image: {
    path: "/static/diagrams/transactionLimit.svg",
    description: "Workflow for a transaction exceeding its limits"
  },
  request: {
    responses: {
      notification: {
      type: 'subject_reproved',
      subject_id: 'UUID', 'items': [ 'tax_declaration_required', 'proof_of_address_missing' ],
      secret: 'some-secret'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/Transaction/TransactionLimits.js